import { JSONSchema7 } from 'json-schema';

export const media_progress = {
  $comment: 'Прогресс медиафайла',
  type: 'string',
  minimum: 1,
  examples: [10],
} as const satisfies JSONSchema7;

export const final_id = {
  $comment: 'ID финального экрана',
  type: 'string',
  examples: ['f2exoj_Q0_'],
} as const satisfies JSONSchema7;

export const final_index = {
  $comment: 'Порядковый номер финального экрана (начинается с 1)',
  type: 'string',
  pattern: '^[1-9][0-9]*$',
  examples: ['1'],
} as const satisfies JSONSchema7;

export const collected_score = {
  $comment: 'Кол-во набранных баллов',
  type: 'string',
  pattern: '^[0-9]$|^[1-9][0-9]*$',
  examples: ['1'],
} as const satisfies JSONSchema7;

export const correct_answers_count = {
  $comment: 'Кол-во правильных ответов',
  type: 'string',
  pattern: '^[0-9]$|^[1-9][0-9]*$',
  examples: ['0'],
} as const satisfies JSONSchema7;

export const user_id = {
  $comment: 'Запрещено к использованию',
  oneOf: [
    { type: 'string', maxLength: 0 },
    { type: 'string', format: 'uuid' },
  ],
} as const satisfies JSONSchema7;

export const twork_id = {
  $comment: 'TWork ID респондента',
  oneOf: [
    { type: 'string', maxLength: 0 },
    { type: 'string', format: 'uuid' },
  ],
  examples: ['935677e6-9a75-4358-b669-f58a322b8c7d'],
} as const satisfies JSONSchema7;

export const question_index = {
  $comment: 'Порядковый номер вопроса (начинается с 0)',
  type: 'string',
  pattern: '^[0-9]*$',
  examples: ['1'],
} as const satisfies JSONSchema7;

export const question_id = {
  $comment: 'ID вопроса',
  type: 'string',
  examples: ['MaJy-OE5MThgGt-Yr50FQ'],
} as const satisfies JSONSchema7;

export const current_hash = {
  $comment: `Первые 14 символов hex сериализации SHA256 хэша от JSON сериализации массива
  [ answeredIds: string[] | undefined, answeredOthers: string | undefined, previousHash: string | null, questionId: string, pollsIc: string, quizId: string ].
  [...new Uint8Array(buffer)].map(x => x.toString(16).padStart(2, '0')).join('').slice(0, 14)`,
  type: 'string',
  examples: ['6862b524833391'],
} as const satisfies JSONSchema7;

export const current_hash_final = {
  $comment: `Первые 14 символов hex сериализации SHA256 хэша от JSON сериализации массива [ finalId: string, pollsIc: string, previousHash: string | null, quizId: string ].
  [...new Uint8Array(buffer)].map(x => x.toString(16).padStart(2, '0')).join('').slice(0, 14)`,
  type: 'string',
  examples: ['6862b524833391'],
} as const satisfies JSONSchema7;

export const previous_hash_final = {
  $comment: 'Значение поля current_hash последнего пикселя answer, либо null если такого пикселя не было',
  type: ['string', 'null'],
  examples: ['6862b5248333919b3cdf155a1cd038325e00fb22c07e56460b31483ae93f4176'],
} as const satisfies JSONSchema7;

export const previous_hash = {
  $comment: 'Значение поля current_hash предыдущего пикселя answer, либо null если это первый такой пиксель',
  type: ['string', 'null'],
  examples: ['6862b5248333919b3cdf155a1cd038325e00fb22c07e56460b31483ae93f4176'],
} as const satisfies JSONSchema7;

export const set_id = {
  $comment: 'ID сета',
  type: 'string',
  examples: ['ap2ju1gCfV'],
} as const satisfies JSONSchema7;

export const group_id = {
  $comment: 'ID группы вопросов',
  type: 'string',
  examples: ['ap2ju1gCfV'],
} as const satisfies JSONSchema7;

export const question_deck_id = {
  $comment: 'ID колоды вопросов',
  type: 'string',
  examples: ['ap2ju1gCfV'],
} as const satisfies JSONSchema7;

export const question_text = {
  $comment: 'Текст вопроса (подстановки будут раскрыты)',
  type: 'string',
  examples: ['Какой у вас опыт в инвестициях?'],
} as const satisfies JSONSchema7;

export const answered_ids = {
  $comment: 'ID показанных ответов (перечисление через запятую)',
  oneOf: [
    { type: 'string', maxLength: 0 },
    { type: 'string', examples: ['jcOG7924sV,4m2nsj_cz1,nnJU9_NQsF'] },
  ],
} as const satisfies JSONSchema7;

export const answered_indexes = {
  $comment: 'Порядковый номер ответа (начинается с 0, перечисление через запятую)',
  type: 'string',
  oneOf: [
    { type: 'string', maxLength: 0 },
    { type: 'string', examples: ['0,1,3'] },
  ],
} as const satisfies JSONSchema7;

export const answered_others = {
  $comment: 'Произвольное текстовое значение ответа',
  oneOf: [
    {
      $comment: 'Введенный респондентом текст',
      type: 'string',
      examples: ['То что легко переводить между счетами в любой момент и процент хороший'],
    },
    {
      $comment: 'POLL_FILE: Внутренний путь до загруженного файла',
      type: 'string',
      examples: [
        'clt6w5d9602td01kf9j2aak23_WZ8KEQIJmJ/8138e232-cec0-487b-8c81-ac02f5e3e4ed_44b1815/Screenshot_13_1709198182534592105.png',
      ],
    },
    {
      $comment: 'POLL_CLICK_MAP: указанные точки с их комментариями',
      type: 'string',
      examples: [''],
    },
    {
      $comment: 'POLL_MAXDIFF: ',
      type: 'string',
      examples: [
        '{\'Повышенная ставка по вкладу\',\'Повышенный лимит кэшбэка\',\'Бесплатные push-уведомления и смс по карте\',\'Оплата ЖКХ без комиссии\',\'Бесплатное обслуживание навсегда\',\'3 месяца бесплатной мобильной связи от Тинькофф Мобайл\',\'Фиксированная повышенная категория кэшбэка (супермаркеты, рестораны, аптеки или транспорт)\',\'3 месяца бесплатной подписки на Тинькофф Премиум\',\'Бонусная акция на Тинькофф.Инвестициях\',\'Сниженная ставка по кредиту или ипотеке\',\'1,5% баллами за все покупки по кредитной карте Тинькофф Платинум\',\'Разовой денежный бонус\',\'Бесплатное снятие наличных в любых банкоматах\',\'Скидка на мобильную связь Тинькофф Мобайл\',\'3 месяца бесплатной подписки на Тинькофф Про\',\'Разовый кэшбек на первое начисление зарплаты\',\'3 месяца бесплатной подписки на Тинькофф Премиум\',\'Разовой денежный бонус\',\'Бонусная акция на Тинькофф.Инвестициях\',\'Бесплатное снятие наличных в любых банкоматах\',\'Бесплатные push-уведомления и смс по карте\',\'Скидка на мобильную связь Тинькофф Мобайл\',\'3 месяца бесплатной мобильной связи от Тинькофф Мобайл\',\'Сниженная ставка по кредиту или ипотеке\',\'Разовый кэшбек на первое начисление зарплаты\',\'Повышенная ставка по вкладу\',\'Фиксированная повышенная категория кэшбэка (супермаркеты, рестораны, аптеки или транспорт)\',\'Бесплатное обслуживание навсегда\',\'Повышенный лимит кэшбэка\',\'3 месяца бесплатной подписки на Тинькофф Про\',\'Оплата ЖКХ без комиссии\',\'1,5% баллами за все покупки по кредитной карте Тинькофф Платинум\',\'1,5% баллами за все покупки по кредитной карте Тинькофф Платинум\',\'Повышенный лимит кэшбэка\',\'3 месяца бесплатной подписки на Тинькофф Премиум\',\'3 месяца бесплатной мобильной связи от Тинькофф Мобайл\',\'Бесплатное обслуживание навсегда\',\'Разовой денежный бонус\',\'Оплата ЖКХ без комиссии\',\'Повышенная ставка по вкладу\',\'Бесплатное снятие наличных в любых банкоматах\',\'Разовый кэшбек на первое начисление зарплаты\',\'Бонусная акция на Тинькофф.Инвестициях\',\'Фиксированная повышенная категория кэшбэка (супермаркеты, рестораны, аптеки или транспорт)\',\'Сниженная ставка по кредиту или ипотеке\',\'Бесплатные push-уведомления и смс по карте\',\'3 месяца бесплатной подписки на Тинькофф Про\',\'Скидка на мобильную связь Тинькофф Мобайл\',\'[{"maximumId":"qeMk8PEEdZ","minimumId":"KN6Ov5hFjJ","answers":["qeMk8PEEdZ","DHuIZyH9_h","SUyRoyiUQG","KN6Ov5hFjJ"]},{"maximumId":"AOd9HgvIlo","minimumId":"4cKO1rwNsY","answers":["AOd9HgvIlo","4cKO1rwNsY","mkLKbXC3ow","YJeiNDtDQ-"]},{"maximumId":"iLEDFZAsRX","minimumId":"CCxCntcNNV","answers":["SPvNQq44S4","CCxCntcNNV","AbJUjI0ox7","iLEDFZAsRX"]},{"maximumId":"alab8K2WN_","minimumId":"oULL9pZ78R","answers":["alab8K2WN_","oULL9pZ78R","L_TNYHUfMA","Lh1f58lnor"]},{"maximumId":"alab8K2WN_","minimumId":"YJeiNDtDQ-","answers":["YJeiNDtDQ-","iLEDFZAsRX","SPvNQq44S4","alab8K2WN_"]},{"maximumId":"4cKO1rwNsY","minimumId":"SUyRoyiUQG","answers":["SUyRoyiUQG","oULL9pZ78R","4cKO1rwNsY","CCxCntcNNV"]},{"maximumId":"mkLKbXC3ow","minimumId":"qeMk8PEEdZ","answers":["Lh1f58lnor","qeMk8PEEdZ","mkLKbXC3ow","AOd9HgvIlo"]},{"maximumId":"DHuIZyH9_h","minimumId":"KN6Ov5hFjJ","answers":["DHuIZyH9_h","L_TNYHUfMA","KN6Ov5hFjJ","AbJUjI0ox7"]},{"maximumId":"DHuIZyH9_h","minimumId":"4cKO1rwNsY","answers":["AbJUjI0ox7","DHuIZyH9_h","YJeiNDtDQ-","4cKO1rwNsY"]},{"maximumId":"AOd9HgvIlo","minimumId":"KN6Ov5hFjJ","answers":["AOd9HgvIlo","iLEDFZAsRX","KN6Ov5hFjJ","qeMk8PEEdZ"]},{"maximumId":"mkLKbXC3ow","minimumId":"SPvNQq44S4","answers":["alab8K2WN_","Lh1f58lnor","SPvNQq44S4","mkLKbXC3ow"]},{"maximumId":"L_TNYHUfMA","minimumId":"CCxCntcNNV","answers":["CCxCntcNNV","SUyRoyiUQG","L_TNYHUfMA","oULL9pZ78R"]}]\'',
      ],
    },
    {
      $comment: 'POLL_CHOICE_CONJOINT: ',
      type: 'string',
      examples: [
        '{"type":"regular","cardIdx":0,"choices":[{"6SmXbmltxeEp6C1zdrJc4":"hD0evc8CO89kK7V6JLKBn","1i0YTmNa-qiI-fV2Mi1JW":"96a1daLT0Kgko16Zffgig","ngFCv78tXOz4AWnG0zIlo":"FcXF5rG7uXbdQa6v-EvpR","zDGqnks7au":"nIMFiHPa4jFfUD16bxPC3","lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu","MtrkYbwsWn5WbI5AJX3qn":"lEsQW5T3nyxyuRkflH7hN"},{"6SmXbmltxeEp6C1zdrJc4":"MyNGHQ9hlxyzkTFbscO0U","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","MtrkYbwsWn5WbI5AJX3qn":"Xfj7JwLy1rN_pxDzpa56X","zDGqnks7au":"5cNh_4B7UIXj_ZLDt6dU_","1i0YTmNa-qiI-fV2Mi1JW":"hh66ibMilEB_tJwitBbqw","ngFCv78tXOz4AWnG0zIlo":"Bpreq2vwFc0X2VhRPTijD"},{"MtrkYbwsWn5WbI5AJX3qn":"fJ4IYt5q1aS5WueqaaxXO","ngFCv78tXOz4AWnG0zIlo":"XF5OGuJDsqWe9pm5DKiWi","6SmXbmltxeEp6C1zdrJc4":"wPIlowMFQju8zHXIC-p_Z","zDGqnks7au":"MxCyd7cTLm","1i0YTmNa-qiI-fV2Mi1JW":"r1lg1XmY1IGuCwLkZK1HX","lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu"},{"MtrkYbwsWn5WbI5AJX3qn":"yXyx782EFGwR4QzpNgnuC","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","1i0YTmNa-qiI-fV2Mi1JW":"96a1daLT0Kgko16Zffgig","ngFCv78tXOz4AWnG0zIlo":"m512Htx1j1RqFY5AW_aLc","6SmXbmltxeEp6C1zdrJc4":"vtBq7MOVwjKf2ZNapFD_R","zDGqnks7au":"3B74DTxo7H3P0_-_Ia1nf"}]},{"type":"regular","cardIdx":1,"choices":[{"6SmXbmltxeEp6C1zdrJc4":"vtBq7MOVwjKf2ZNapFD_R","1i0YTmNa-qiI-fV2Mi1JW":"r1lg1XmY1IGuCwLkZK1HX","zDGqnks7au":"xPX2FXbGgqkueUJZaNhix","MtrkYbwsWn5WbI5AJX3qn":"lEsQW5T3nyxyuRkflH7hN","ngFCv78tXOz4AWnG0zIlo":"Bpreq2vwFc0X2VhRPTijD","lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu"},{"zDGqnks7au":"5cNh_4B7UIXj_ZLDt6dU_","MtrkYbwsWn5WbI5AJX3qn":"fJ4IYt5q1aS5WueqaaxXO","ngFCv78tXOz4AWnG0zIlo":"m512Htx1j1RqFY5AW_aLc","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","1i0YTmNa-qiI-fV2Mi1JW":"hh66ibMilEB_tJwitBbqw","6SmXbmltxeEp6C1zdrJc4":"hD0evc8CO89kK7V6JLKBn"},{"ngFCv78tXOz4AWnG0zIlo":"FcXF5rG7uXbdQa6v-EvpR","zDGqnks7au":"MxCyd7cTLm","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","MtrkYbwsWn5WbI5AJX3qn":"yXyx782EFGwR4QzpNgnuC","6SmXbmltxeEp6C1zdrJc4":"wPIlowMFQju8zHXIC-p_Z","1i0YTmNa-qiI-fV2Mi1JW":"hh66ibMilEB_tJwitBbqw"},{"6SmXbmltxeEp6C1zdrJc4":"MyNGHQ9hlxyzkTFbscO0U","lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu","zDGqnks7au":"3B74DTxo7H3P0_-_Ia1nf","ngFCv78tXOz4AWnG0zIlo":"XF5OGuJDsqWe9pm5DKiWi","MtrkYbwsWn5WbI5AJX3qn":"Xfj7JwLy1rN_pxDzpa56X","1i0YTmNa-qiI-fV2Mi1JW":"96a1daLT0Kgko16Zffgig"}]},{"type":"regular","cardIdx":2,"choices":[{"MtrkYbwsWn5WbI5AJX3qn":"fJ4IYt5q1aS5WueqaaxXO","lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu","1i0YTmNa-qiI-fV2Mi1JW":"r1lg1XmY1IGuCwLkZK1HX","6SmXbmltxeEp6C1zdrJc4":"MyNGHQ9hlxyzkTFbscO0U","zDGqnks7au":"nIMFiHPa4jFfUD16bxPC3","ngFCv78tXOz4AWnG0zIlo":"FcXF5rG7uXbdQa6v-EvpR"},{"ngFCv78tXOz4AWnG0zIlo":"XF5OGuJDsqWe9pm5DKiWi","1i0YTmNa-qiI-fV2Mi1JW":"hh66ibMilEB_tJwitBbqw","MtrkYbwsWn5WbI5AJX3qn":"lEsQW5T3nyxyuRkflH7hN","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","6SmXbmltxeEp6C1zdrJc4":"vtBq7MOVwjKf2ZNapFD_R","zDGqnks7au":"xPX2FXbGgqkueUJZaNhix"},{"1i0YTmNa-qiI-fV2Mi1JW":"96a1daLT0Kgko16Zffgig","6SmXbmltxeEp6C1zdrJc4":"wPIlowMFQju8zHXIC-p_Z","zDGqnks7au":"5cNh_4B7UIXj_ZLDt6dU_","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","ngFCv78tXOz4AWnG0zIlo":"Bpreq2vwFc0X2VhRPTijD","MtrkYbwsWn5WbI5AJX3qn":"Xfj7JwLy1rN_pxDzpa56X"},{"lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu","zDGqnks7au":"MxCyd7cTLm","1i0YTmNa-qiI-fV2Mi1JW":"r1lg1XmY1IGuCwLkZK1HX","6SmXbmltxeEp6C1zdrJc4":"hD0evc8CO89kK7V6JLKBn","MtrkYbwsWn5WbI5AJX3qn":"yXyx782EFGwR4QzpNgnuC","ngFCv78tXOz4AWnG0zIlo":"m512Htx1j1RqFY5AW_aLc"}]},{"type":"regular","cardIdx":2,"choices":[{"1i0YTmNa-qiI-fV2Mi1JW":"hh66ibMilEB_tJwitBbqw","MtrkYbwsWn5WbI5AJX3qn":"lEsQW5T3nyxyuRkflH7hN","zDGqnks7au":"nIMFiHPa4jFfUD16bxPC3","ngFCv78tXOz4AWnG0zIlo":"m512Htx1j1RqFY5AW_aLc","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","6SmXbmltxeEp6C1zdrJc4":"wPIlowMFQju8zHXIC-p_Z"},{"ngFCv78tXOz4AWnG0zIlo":"Bpreq2vwFc0X2VhRPTijD","1i0YTmNa-qiI-fV2Mi1JW":"r1lg1XmY1IGuCwLkZK1HX","6SmXbmltxeEp6C1zdrJc4":"hD0evc8CO89kK7V6JLKBn","MtrkYbwsWn5WbI5AJX3qn":"Xfj7JwLy1rN_pxDzpa56X","lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu","zDGqnks7au":"3B74DTxo7H3P0_-_Ia1nf"},{"zDGqnks7au":"xPX2FXbGgqkueUJZaNhix","ngFCv78tXOz4AWnG0zIlo":"FcXF5rG7uXbdQa6v-EvpR","1i0YTmNa-qiI-fV2Mi1JW":"96a1daLT0Kgko16Zffgig","lDHEKACyVk39-ShLclbaw":"SHR3RhbtLRRQn9sAj-qrz","MtrkYbwsWn5WbI5AJX3qn":"fJ4IYt5q1aS5WueqaaxXO","6SmXbmltxeEp6C1zdrJc4":"vtBq7MOVwjKf2ZNapFD_R"},{"zDGqnks7au":"3B74DTxo7H3P0_-_Ia1nf","6SmXbmltxeEp6C1zdrJc4":"MyNGHQ9hlxyzkTFbscO0U","1i0YTmNa-qiI-fV2Mi1JW":"hh66ibMilEB_tJwitBbqw","lDHEKACyVk39-ShLclbaw":"GsawmYuD-hiB6ksx-zdeu","ngFCv78tXOz4AWnG0zIlo":"XF5OGuJDsqWe9pm5DKiWi","MtrkYbwsWn5WbI5AJX3qn":"yXyx782EFGwR4QzpNgnuC"}]}',
      ],
    },
    {
      $comment: 'POLL_PROTOTYPE_SCREEN: клики респондента',
      type: 'string',
      examples: ['{"clicks":[{"x":0.6017156862745098,"y":0.8804347826086957}],"missclicks":0}'],
    },
  ],
} as const satisfies JSONSchema7;

export const answers = {
  $comment: 'Перечисление показанных пользователю ответов (подстановки будут раскрыты)',
  oneOf: [
    { type: 'string', maxLength: 0 },
    {
      type: 'string',
      examples: [
        'i3dXHbWbvx9QkdobtMN8e:"Никогда не инвестировал",ov24f7n06z-aHRJaDg_x1:"Пробовал инвестировать",f2weU9zlXTai6mWGD-1Z5:"Давно инвестирую",Kl1l1Vvzrwha_ay9ksHuQ:"Я трейдер"',
      ],
    },
  ],
} as const satisfies JSONSchema7;

export const elapsed_time = {
  $comment: 'Кол-во времени в ms до ответа',
  type: 'string',
  pattern: '^[1-9][0-9]*$',
  examples: ['84598537'],
} as const satisfies JSONSchema7;

export const time_expired = {
  $comment: 'Флаг - время таймера истекло',
  type: 'string',
  enum: ['0', '1'],
  examples: ['1'],
} as const satisfies JSONSchema7;

export const question_type = {
  $comment: 'Тип вопроса',
  type: 'string',
  oneOf: [
    { const: 'POLL_SINGLE', $comment: 'Одиночный выбор' },
    { const: 'POLL_SINGLE_WITH_PICTURE', $comment: 'Одиночный выбор с картинкой' },
    { const: 'POLL_MULTIPLE', $comment: 'Множественный выбор' },
    { const: 'POLL_MULTIPLE_WITH_PICTURE', $comment: 'Множественный выбор с картинкой' },
    { const: 'POLL_SINGLE_FROM_PICTURE', $comment: 'Одиночный выбор между картинками' },
    { const: 'POLL_MULTIPLE_FROM_PICTURE', $comment: 'Множественный выбор между картинками' },
    { const: 'POLL_RANK', $comment: 'Ранжирование' },
    { const: 'POLL_RATING', $comment: 'Рейтинг' },
    { const: 'POLL_RATING_WITH_PICTURE', $comment: 'Рейтинг с картинкой' },
    { const: 'POLL_TEXTAREA', $comment: 'Свободный ввод' },
    { const: 'POLL_SELECT', $comment: 'Выпадающий список' },
    { const: 'POLL_MULTIPLE_SELECT', $comment: 'Выпадающий список со множественным выбором' },
    { const: 'MATRIX_POLL_SINGLE', $comment: 'Матрица: одиночный выбор' },
    { const: 'MATRIX_POLL_MULTIPLE', $comment: 'Матрица: множественный выбор' },
    { const: 'MATRIX_POLL_RATING_DIGITS', $comment: 'Матрица: рейтинг: цифры' },
    { const: 'MATRIX_POLL_RATING_STARS', $comment: 'Матрица: рейтинг: звезды' },
    { const: 'POLL_CLICK_MAP', $comment: 'Карта кликов' },
    { const: 'POLL_FILE', $comment: 'Загрузка файла' },
    { const: 'MEDIA_FILE_ANY', $comment: 'Показать контент: произвольный' },
    { const: 'MEDIA_FILE_IMAGE', $comment: 'Показать контент: изображение' },
    { const: 'MEDIA_FILE_AUDIO', $comment: 'Показать контент: аудио' },
    { const: 'MEDIA_FILE_VIDEO', $comment: 'Показать контент: видео' },
    { const: 'MEDIA_FILE_TEXT', $comment: 'Показать контент: текст' },
    { const: 'POLL_AUTH', $comment: 'Авторизация' },
    { const: 'POLL_MAXDIFF', $comment: 'MaxDiff' },
    { const: 'POLL_CHOICE_CONJOINT', $comment: 'Choice-Based Conjoint' },
    { const: 'POLL_PROTOTYPE_SCREEN', $comment: 'Тестирование прототипов' },
  ],
} as const satisfies JSONSchema7;

export const media_question_type = {
  $comment: 'Тип вопроса',
  type: 'string',
  oneOf: [
    { const: 'MEDIA_FILE_ANY', $comment: 'Показать контент: произвольный' },
    { const: 'MEDIA_FILE_IMAGE', $comment: 'Показать контент: изображение' },
    { const: 'MEDIA_FILE_AUDIO', $comment: 'Показать контент: аудио' },
    { const: 'MEDIA_FILE_VIDEO', $comment: 'Показать контент: видео' },
    { const: 'MEDIA_FILE_TEXT', $comment: 'Показать контент: текст' },
  ],
} as const satisfies JSONSchema7;

export const external_url = {
  $comment: 'URL ссылки',
  type: 'string',
  examples: ['https://example.com/'],
} as const satisfies JSONSchema7;

export const file_name = {
  $comment: 'Название файла',
  type: 'string',
  examples: ['example.png'],
} as const satisfies JSONSchema7;

export const file_path = {
  $comment: 'Идентификатор загруженного файла для polls site',
  type: 'string',
  examples: [
    'clwt7sp9y000s0eunges7e9jl_SiKTVpVZMd/16914f0b-2236-4457-b9fd-71818c10c2ca_96d8577c/2_1717071161237441964.jpeg',
  ],
} as const satisfies JSONSchema7;

export const file_is_uploaded = {
  $comment: 'Флаг, указывающий на то, был ли успешно загружен файл',
  type: 'string',
  examples: ['0', '1'],
} as const satisfies JSONSchema7;

export const questions_count = {
  $comment: 'Количество вопросов',
  type: 'integer',
  minimum: 1,
  examples: [10],
} as const satisfies JSONSchema7;

export const final_number = {
  $comment: 'Порядковый номер финального экрана (начинается с 1)',
  type: 'string',
  pattern: '^[1-9][0-9]*$',
  examples: ['1'],
} as const satisfies JSONSchema7;

export const answers_overall = {
  $comment: 'Ответы респондента',
  type: 'array',
  items: {
    type: 'object',
    required: ['question_index', 'question_id', 'question_text', 'question_type', 'answered_ids', 'answers'],
    additionalProperties: false,
    properties: {
      set_id,
      group_id,
      question_deck_id,
      question_id,
      question_index,
      question_text,
      question_type,
      answered_ids,
      answered_indexes,
      answered_others,
      answers,
      collected_score,
      elapsed_time,
    },
  },
} as const satisfies JSONSchema7;
